import {
  type FieldErrors,
  type UseFormRegister,
  type UseFormSetValue,
} from "react-hook-form";

import { Item, Select, TextInput } from "@icg360/design-system";

import { states } from "consts";
import { type EditMortgageeModalFields } from "pages/settings/payment/payment-item/edit-mortgagee/edit-mortgagee-modal/index";

import styles from "./edit-mortgagee-modal.module.scss";

type ManualMortgageeProps = {
  register: UseFormRegister<EditMortgageeModalFields>;
  setValue: UseFormSetValue<EditMortgageeModalFields>;
  errors: FieldErrors<EditMortgageeModalFields>;
};

export const ManualMortgagee = ({
  register,
  errors,
  setValue,
}: ManualMortgageeProps) => {
  const onStateSelection = (key) => {
    setValue("state", key);
  };

  return (
    <>
      <TextInput
        {...register("name")}
        label="Mortgage company"
        errorMessage={errors.name?.message}
        isError={!!errors.name}
      />
      <TextInput
        {...register("street1")}
        label="Address line 1"
        errorMessage={errors.street1?.message}
        isError={!!errors.street1}
      />
      <TextInput
        {...register("street2")}
        label="Address line 2"
        errorMessage={errors.street2?.message}
        isError={!!errors.street2}
        isOptional
      />
      <div className={styles.cityStateZip}>
        <div className={styles.city}>
          <TextInput
            {...register("city")}
            label="City"
            errorMessage={errors.city?.message}
            isError={!!errors.city}
          />
        </div>
        <div className={styles.stateZip}>
          <div className={styles.state}>
            <Select
              label="State"
              placeholder=""
              errorMessage={errors.state?.message}
              isError={!!errors.state}
              onSelectionChange={onStateSelection}
              fluid
            >
              {states.map(({ abbreviation, name }) => {
                return <Item key={abbreviation}>{name}</Item>;
              })}
            </Select>
          </div>
          <div className={styles.zip}>
            <TextInput
              {...register("zip")}
              label="Zip"
              errorMessage={errors.zip?.message}
              isError={!!errors.zip}
            />
          </div>
        </div>
      </div>
    </>
  );
};
